export default function parseFilterResp(resp: any) {

    if (!resp || !resp.data || !resp.data.length) {
        return [];
    }
    return resp.data.map((item: { id: number, name: string }) => {
        return {...item, selected: false, disabled: false, order: 0}
    });
}